import React, { useEffect, Fragment } from 'react'
import { cardSize, PickingSquareColors } from '../../const/pickingReportConst'
import { CardChart } from '../../../Charts/CardChart/CardChart'
import { useStyles } from './styles'
import { usePickingReport } from '../../Context/usePickingReport'
import { Typography } from '@mui/material'
import { useZones } from '../../../../hooks'

export interface PickingCard {
  title: string
  subtitle: string
  id: number
}

export const PickingCards = () => {
  const classes = useStyles()
  const {
    state: { cardsItems, selectedZone }
  } = usePickingReport()

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  return (
    <Fragment>
      {cardsItems.length > 0 && (
        <Typography
          variant='h5'
          component='h5'
          style={{ fontWeight: 'bold', margin: '0 20px' }}
        >
          {selectedZone > 0
            ? zones?.filter((x) => x.zoneId == selectedZone)[0].zoneName ||
              'Todas'
            : 'Todas'}
        </Typography>
      )}

      <div className={classes.cardsContainer}>
        {cardsItems.map(({ title, id, qty }) => (
          <CardChart
            key={id}
            title={qty.toString()}
            color={
              PickingSquareColors.find((element) => element.id === id)?.color ||
              ''
            }
            subTitle={title}
            maxHeight={cardSize.maxHeight}
            maxWidth={cardSize.maxWidth}
          />
        ))}
      </div>
    </Fragment>
  )
}
